export const STAGE_PROSPECT = 'Prospect Chaud'
export const STAGE_CANDIDAT = 'Candidat'
export const STAGE_ETUDIANT = 'Etudiant'
export const STAGE_ALUMNI = 'Alumni'
